import React from "react";
import ComingSoon from "../components/ComingSoon.jsx";

export default function DataMigration() {
  return (
    <ComingSoon
      title="Data Migration"
      description="Bring in your existing client, caregiver, and staff records in bulk"
      sections={[
        {
          heading: "Planned",
          items: [
            "CSV import for Clients",
            "CSV import for Employees / Caregivers",
            "Import mapping (matches your existing spreadsheet column names automatically, like Coverra CRM's importer)",
          ],
        },
        {
          heading: "Available today",
          items: ["Add records one at a time via each module's '+ Add' button"],
        },
      ]}
    />
  );
}
